import abl from '../../abl';
import GoogleSheetProcessor from '../google/google_sheet_processor';

const fixtures = abl.config.fixtures;

const MockAPI = abl.createClass({
  initialize: function() {
    this.authenticated = true;
    this.initialized = true;
  },

  authenticate: function(callback) {
    if(this.initialized) {
      callback(this.authenticated);
    }
  },

  getFiles: function(props) {
    let term = props.term;
    return new Promise((resolve, reject) => {
      return resolve({ result: fixtures.getTermFolder(term) })
    })
  },

  getSheet: function(props) {
    return new Promise((resolve, reject) => {
      let processor = new GoogleSheetProcessor(
        fixtures.getFixtureSheet(props.spreadsheetId),
        props.version
      );
      return resolve(processor.toJSON());
    })
  },

  updateSheet: function(props) {
    return new Promise((resolve, reject) => {
      return reject(new Error("not implemented in mock API yet"))
    })
  },

  batchUpdateSheet: function(props) {
    return new Promise((resolve, reject) => {
      return reject(new Error("not implemented in mock API yet"))
    })
  }
});

export default MockAPI;


/** WEBPACK FOOTER **
 ** ./src/js/clients/mock/mock_api.js
 **/